import SlimSelect from 'slim-select';
import { debounce } from '../Utility/DebounceUtility';
import {initMultipleDownloadButtons} from '../Utility/MultipleDownloadButtonUtility';

export class SearchResultsController {

  private readonly categoriesElement: HTMLElement | null = document.querySelector('.js-searchCategories');
  private readonly resultContainerElement: HTMLElement | null = document.querySelector('.js-searchResults');
  private readonly headerElement: HTMLElement | null = document.querySelector('.js-searchHeader');
  private readonly headerInputElement: HTMLElement | null = document.querySelector('.js-searchHeaderInput');
  private readonly productFilters: HTMLElement | null = document.querySelector('.js-productFilters');
  private readonly productFilterToggle: HTMLElement | null = document.querySelector('.js-filterToggle');
  private readonly resetButton: HTMLButtonElement | null = document.querySelector('.js-resetButton');
  private readonly productCatFilters: NodeListOf<HTMLSelectElement> | null = document.querySelectorAll('.js-productFilter');
  private filters = [];

  constructor() {
    if (this.categoriesElement) {

      document.addEventListener('scroll', () => {
        if (this.categoriesElement && this.headerElement) {

          if (window.pageYOffset >= this.headerElement.offsetHeight) {
            this.categoriesElement?.classList.add('search__categories--sticky');
          } else {
            this.categoriesElement?.classList.remove('search__categories--sticky');
          }
        }
      });
    }
    this.bindResultButtonMore();
    this.initSelects();
    this.initSuggestions();

    window.addEventListener('scroll', () => {
      const resultButtonMore: HTMLAnchorElement | null = document.querySelector('.js-resultButtonMore');
      if (resultButtonMore && this.isInViewport(resultButtonMore)) {
        resultButtonMore.click();
      }
    });

    if (this.productFilterToggle) {
      this.productFilterToggle.addEventListener('click', () => {
        if (this.productFilters && this.productFilterToggle) {
          this.productFilters.classList.toggle('search__productFilters--open');
          this.productFilterToggle.classList.toggle('productFilters__toggle--open');
        }
      });
    }

    if (this.resetButton) {
      this.resetButton.addEventListener('click', () => {
        this.resetFilters();
      });
    }

    setTimeout(
      () => {
        if (document.documentElement.scrollTop <= 100) {
          if (this.headerInputElement) {
            this.headerInputElement.focus();
          }
        }
      },
      200,
    );
  }

  private resetFilters(reloadPage: boolean = true) {
    const query = this.filters['tx_dffsearch_search[q]'];
    this.filters = [];
    this.filters['tx_dffsearch_search[filter][0]'] = 'pageHierarchy:type-products-facet-field';
    if (this.productCatFilters && this.productCatFilters[0].value) {
      this.filters['tx_dffsearch_search[filter][category_level_0_name_stringS]'] = this.productCatFilters[0].value;
    }
    if (query) {
      this.filters['tx_dffsearch_search[q]'] = query;
    }
    if (reloadPage) {
      this.reloadPage();
    }
  }

  private bindResultButtonMore(): void {
    const resultButtonMore: HTMLAnchorElement | null = document.querySelector('.js-resultButtonMore');
    if (!resultButtonMore) {
      return;
    }
    resultButtonMore.addEventListener('click', async (mouseEvent: MouseEvent): Promise<undefined> => {
      const resultsElements: NodeListOf<Element> | null = document.querySelectorAll('.js-result ul');
      if (!resultsElements) {
        return;
      }
      const resultElement = resultsElements[resultsElements.length - 1];
      const url = resultButtonMore.getAttribute('data-uri');
      if (!url) {
        return;
      }

      mouseEvent.stopPropagation();
      mouseEvent.preventDefault();

      const historyHref = resultButtonMore.getAttribute('href');
      if (historyHref) {
        window.history.pushState({}, '', historyHref);
      }

      resultButtonMore.remove();

      const response = await fetch(url);
      if (!response.ok) {
        return;
      }
      const html: string = await response.text();
      resultElement.insertAdjacentHTML('beforeend', html);
      initMultipleDownloadButtons();
      this.bindResultButtonMore();
    });
  }

  private initSelects() {
    if (this.productCatFilters) {
      const search = new URLSearchParams(window.location.search);
      let filters = [];
      search.forEach(function (value: string, key: string) {
        if (key.indexOf('tx_dffsearch_search[filter]') === 0 || key.indexOf('tx_dffsearch_search[q]') === 0) {
          filters[key] = value;
        }
      });

      this.filters = filters;
      for (let i = 0; i < this.productCatFilters.length; i++) {
        let slimSelect;
        if (i > 0) {
          slimSelect = new SlimSelect({
            select: this.productCatFilters[i],
            showSearch: false,
            allowDeselect: true,
            deselectLabel: '<div class="filter__deselect"><i class="icon icon--x" aria-hidden="true"></i></div>',
          });
        } else {
          slimSelect = new SlimSelect({
            select: this.productCatFilters[i],
            showSearch: false,
            placeholder: this.productCatFilters[i].dataset.placeholder,
            allowDeselect: true,
            deselectLabel: '<div class="filter__deselect"><i class="icon icon--x" aria-hidden="true"></i></div>',
          });
        }

        const facetName = this.productCatFilters[i].dataset.facetField || '';
        const filterForFacetName = this.filters['tx_dffsearch_search[filter][' + facetName + ']'];
        if (filterForFacetName) {
          slimSelect.set(filterForFacetName);
        }
        this.productCatFilters[i].addEventListener('change', () => {
          if (!this.productCatFilters) {
            return;
          }
          if (this.productCatFilters[i].value !== '') {
            if (facetName === 'category_level_0_name_stringS') {
              this.resetFilters(false);
            }
            this.filters['tx_dffsearch_search[filter][' + facetName + ']'] = this.productCatFilters[i].value;
          } else if (this.filters['tx_dffsearch_search[filter][' + facetName + ']']) {
            delete this.filters['tx_dffsearch_search[filter][' + facetName + ']'];
            if (facetName === 'category_level_0_name_stringS') {
              this.resetFilters(false);
            }
          }
          this.reloadPage();
        });
      }
    }
  }

  private reloadPage() {
    let searchParams = new URLSearchParams();
    for (let key of Object.keys(this.filters)) {
      searchParams.append(key, this.filters[key]);
    }
    window.location.search = '?' + searchParams;
  }

  private initSuggestions() {
    if (this.headerElement) {
      const queryInput: any = this.headerElement.querySelector('.js-solr-q');

      if (!queryInput) {
        return;
      }

      queryInput.addEventListener('keyup', debounce(
        () => {
          this.updateResults();
        },
        200,
      ));

      /* reset on clear and esc key */
      queryInput.addEventListener('search', (event) => {
        this.updateResults();
      });
    }
  }

  private async updateResults() {
    const inputElement: HTMLInputElement | null = document.querySelector('.js-solr-q');
    if (!inputElement) {
      return;
    }

    const ajaxUrl = inputElement?.dataset.result;
    const params: URLSearchParams = (new URL(document.location.href)).searchParams;

    /* overwrite existing query searchParam or creates new one */
    params.set('tx_dffsearch_search[q]', inputElement.value);
    const url = `${ajaxUrl}&${params.toString()}`;
    history.pushState(params.toString(), '', `?${params.toString()}`);

    const response = await fetch(url);
    if (!response.ok) {
      return;
    }
    const html: string = await response.text();
    const node = document.createElement('div');
    node.innerHTML = html;

    const nodeCategories = node.querySelector('.js-searchCategories');
    const nodeResults = node.querySelector('.js-searchResults');
    /* replace content with response */
    if (nodeCategories && this.categoriesElement) {
      this.categoriesElement.innerHTML = nodeCategories.innerHTML;
    }
    if (nodeResults && this.resultContainerElement) {
      this.resultContainerElement.innerHTML = nodeResults.innerHTML;
    }

    this.bindResultButtonMore();
    initMultipleDownloadButtons();
  }

  private isInViewport(element: HTMLElement): boolean {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
